(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bakhoor-home"] && !Shopify.designMode) return;
  try {
    
function initBakhoor(root) {
  const panels = root.querySelectorAll('[data-panel]');
  const buttons = root.querySelectorAll('button[data-scent]');
  root.querySelectorAll('[data-scent]').forEach(control => {
    control.addEventListener('click', () => {
      const scent = control.dataset.scent;
      panels.forEach(panel => { panel.hidden = panel.dataset.panel !== scent; });
      buttons.forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.scent === scent)); });
    });
  });
}
document.querySelectorAll('.bk-home').forEach(initBakhoor);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.bk-home').forEach(initBakhoor));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
